import { Link } from "gatsby";
import React from "react";
import doubleQuotesDark from "../../../assets/images/comillas.png";
import "./quote.scss";
export interface IQuote {
  imgUrl: string;
  text: string;
  author: string;
  botton: string;
  link: string;
}

const Quote = (props: IQuote) => {
  return (
    <div className="quote">
      <div className="quote__line"></div>
      <div className="quote__image">
        <img src={props.imgUrl} alt="David Escobar" />
      </div>
      <div className="quote__content">
        <div className="quote__content-img">
          <img src={doubleQuotesDark} alt="doble-quote" />
        </div>
        <div className="quote__content-text">
          <p>{props.text}</p>
        </div>
        <div className="quote__content-author">
          <p>{props.author}</p>
        </div>
        <Link to={props.link} className="quote__content-link">
          <div className="quote__content-botton">
            <span>{props.botton}</span>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Quote;
